import { type QueryKey, useQueryClient } from '@tanstack/react-query';
import { useTranslations } from '@power-core/toolkit';

import { useAppContext } from '@/modules/app-context/use-app-context';

import { useNavigation } from './use-navigation';

export const useApi = ({ queryKey, closeModal = true }: { queryKey: QueryKey; closeModal?: boolean }) => {
	const t = useTranslations();
	const { removeAllSearchParams } = useNavigation();
	const { showToast } = useAppContext();
	const queryClient = useQueryClient();

	const onSuccess = (messageKey?: string) => {
		if (queryKey) queryClient.invalidateQueries({ queryKey });
		if (closeModal) removeAllSearchParams();
		if (messageKey) showToast({ message: t(messageKey ?? '') });
	};

	return {
		onSuccess,
	};
};
